var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useCallback, useEffect, useRef, useState } from "react";
import { FormattedMessage, FormattedDate, useIntl } from "react-intl";
import { useHistory, useLocation } from "react-router-dom";
import { PaneMenu, Button, MultiColumnList, Accordion, AccordionSet, Tooltip, Layout, Headline, Datepicker, Select, Callout, Icon, TextField, Loading, } from "@folio/stripes/components";
import { useOkapiKy } from "@folio/stripes/core";
import { useQuery } from "react-query";
import { UserStatusEnum } from "../types/api";
import SearchLayout from "../components/SearchLayout";
import AuditLogDetailPane from "../components/AuditLogDetailPane";
import useAuditLogList from "../hooks/useAuditLogList";
import { fetchAuditLogExport } from "../api/auditLogService";
import { fetchUsers, buildUserSearchQuery } from "../api/userService";
import { ACTION_TYPE_OPTIONS } from "./auditLogActionTypeOptions";
var EXPORT_LIMIT = 10000;
var ENTITY_TYPE_OPTIONS = ["USER", "ORGANIZATION", "RECORD", "PROPOSAL"];
var AuditLogList = function (_a) {
    var selectedId = _a.selectedId;
    var intl = useIntl();
    var history = useHistory();
    var location = useLocation();
    var ky = useOkapiKy();
    var list = useAuditLogList();
    var _b = useState(false), isExporting = _b[0], setIsExporting = _b[1];
    var _c = useState(""), userSearchTerm = _c[0], setUserSearchTerm = _c[1];
    var _d = useState(""), debouncedUserSearch = _d[0], setDebouncedUserSearch = _d[1];
    var debounceTimerRef = useRef(undefined);
    useEffect(function () {
        debounceTimerRef.current = setTimeout(function () { return setDebouncedUserSearch(userSearchTerm); }, 300);
        return function () { return clearTimeout(debounceTimerRef.current); };
    }, [userSearchTerm]);
    var calloutRef = React.useRef(null);
    // User autocomplete search (debounced)
    var _f = useQuery(["czna-users", "user-search", debouncedUserSearch], function () {
        return fetchUsers(ky, {
            query: buildUserSearchQuery(debouncedUserSearch, "ALL"),
            limit: 10,
        });
    }, {
        enabled: debouncedUserSearch.length >= 2,
        keepPreviousData: true,
    }), userSearchResults = _f.data, isUserSearchLoading = _f.isLoading;
    var goToList = useCallback(function () {
        history.push("/czna-users/audit-log".concat(location.search));
    }, [history]);
    var handleRowClick = useCallback(function (_e, row) {
        history.push("/czna-users/audit-log/".concat(row.id).concat(location.search));
    }, [history]);
    var handleExport = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setIsExporting(true);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, fetchAuditLogExport(ky, list.appliedFilters)];
                case 2:
                    _c.sent();
                    return [3 /*break*/, 5];
                case 3:
                    _a = _c.sent();
                    (_b = calloutRef.current) === null || _b === void 0 ? void 0 : _b.sendCallout({
                        type: "error",
                        message: intl.formatMessage({
                            id: "ui-czna-users.auditLog.export.error",
                        }),
                    });
                    return [3 /*break*/, 5];
                case 4:
                    setIsExporting(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [ky, list.appliedFilters, intl]);
    var handleUserSelect = useCallback(function (user) {
        list.setUserId(user.id);
        list.setUserName("".concat(user.lastName, ", ").concat(user.firstName).concat(user.status === UserStatusEnum.INACTIVE ? " ".concat(intl.formatMessage({ id: "ui-czna-users.auditLog.filter.user.archived" })) : ""));
        setUserSearchTerm("");
    }, [list, intl]);
    var handleClearUser = useCallback(function () {
        list.setUserId("");
        list.setUserName("");
        setUserSearchTerm("");
    }, [list]);
    var resultsFormatter = {
        createdAt: function (row) { return (React.createElement(FormattedDate, { value: row.createdAt, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" })); },
        actionType: function (row) {
            var id = "ui-czna-users.auditLog.actionType.".concat(row.actionType);
            return intl.formatMessage({ id: id, defaultMessage: row.actionType });
        },
        userName: function (row) {
            var MAX_LENGTH = 30;
            if (row.userName.length <= MAX_LENGTH)
                return row.userName;
            var truncated = "".concat(row.userName.slice(0, MAX_LENGTH), "...");
            return (React.createElement(Tooltip, { text: row.userName, id: "user-tooltip-".concat(row.id) }, function (_a) {
                var ref = _a.ref, ariaIds = _a.ariaIds;
                return (React.createElement("span", { ref: ref, "aria-labelledby": ariaIds.text }, truncated));
            }));
        },
        entityType: function (row) {
            var id = "ui-czna-users.auditLog.entityType.".concat(row.entityType);
            return intl.formatMessage({ id: id, defaultMessage: row.entityType });
        },
        summary: function (row) {
            var MAX_LENGTH = 50;
            if (row.summary.length <= MAX_LENGTH)
                return row.summary;
            var truncated = "".concat(row.summary.slice(0, MAX_LENGTH), "...");
            return (React.createElement(Tooltip, { text: row.summary, id: "summary-tooltip-".concat(row.id) }, function (_a) {
                var ref = _a.ref, ariaIds = _a.ariaIds;
                return (React.createElement("span", { ref: ref, "aria-labelledby": ariaIds.text }, truncated));
            }));
        },
    };
    var filterContent = (React.createElement(AccordionSet, null,
        React.createElement(Accordion, { label: intl.formatMessage({
                id: "ui-czna-users.auditLog.filter.dateFrom",
            }), separator: false },
            React.createElement(Datepicker, { label: intl.formatMessage({
                    id: "ui-czna-users.auditLog.filter.dateFrom",
                }), value: list.filters.dateFrom, onChange: function (_e, formatted, dateString) {
                    return list.setDateFrom(dateString || formatted);
                }, backendDateStandard: "YYYY-MM-DD" }),
            React.createElement(Datepicker, { label: intl.formatMessage({
                    id: "ui-czna-users.auditLog.filter.dateTo",
                }), value: list.filters.dateTo, onChange: function (_e, formatted, dateString) {
                    return list.setDateTo(dateString || formatted);
                }, backendDateStandard: "YYYY-MM-DD" }),
            list.dateValidationError && (React.createElement("div", { style: { color: "#d00", fontSize: "0.85em", marginTop: "4px" } },
                React.createElement(FormattedMessage, { id: list.dateValidationError })))),
        React.createElement(Accordion, { label: intl.formatMessage({
                id: "ui-czna-users.auditLog.filter.actionType",
            }), separator: false },
            React.createElement(Select, { value: list.filters.actionType, onChange: function (e) {
                    return list.setActionType(e.target.value);
                } },
                React.createElement("option", { value: "" }, intl.formatMessage({
                    id: "ui-czna-users.auditLog.filter.actionType.placeholder",
                })),
                ACTION_TYPE_OPTIONS.map(function (group) { return (React.createElement("optgroup", { key: group.label, label: intl.formatMessage({ id: group.label }) }, group.options.map(function (opt) { return (React.createElement("option", { key: opt, value: opt }, intl.formatMessage({
                    id: "ui-czna-users.auditLog.actionType.".concat(opt),
                    defaultMessage: opt,
                }))); }))); }))),
        React.createElement(Accordion, { label: intl.formatMessage({
                id: "ui-czna-users.auditLog.filter.user",
            }), separator: false }, list.filters.userId ? (React.createElement("div", { style: {
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
            } },
            React.createElement("span", { style: { flex: 1 } }, list.userName),
            React.createElement(Button, { buttonStyle: "fieldControl", onClick: handleClearUser },
                React.createElement(Icon, { icon: "times-circle-solid" })))) : (React.createElement(React.Fragment, null,
            React.createElement(TextField, { value: userSearchTerm, onChange: function (e) {
                    return setUserSearchTerm(e.target.value);
                }, placeholder: intl.formatMessage({
                    id: "ui-czna-users.auditLog.filter.user.placeholder",
                }) }),
            isUserSearchLoading && debouncedUserSearch.length >= 2 && (React.createElement(Loading, null)),
            userSearchResults &&
                debouncedUserSearch.length >= 2 &&
                !isUserSearchLoading && (React.createElement("div", { style: {
                    maxHeight: "200px",
                    overflowY: "auto",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                } }, userSearchResults.items.length === 0 ? (React.createElement("div", { style: { padding: "8px", color: "#666" } },
                React.createElement(FormattedMessage, { id: "ui-czna-users.auditLog.filter.user.noResults" }))) : (userSearchResults.items.map(function (user) { return (React.createElement("button", { key: user.id, type: "button", onClick: function () { return handleUserSelect(user); }, style: {
                    display: "block",
                    width: "100%",
                    padding: "6px 8px",
                    textAlign: "left",
                    border: "none",
                    borderBottom: "1px solid #eee",
                    background: "none",
                    cursor: "pointer",
                } },
                user.lastName,
                ", ",
                user.firstName,
                " (",
                user.email,
                ")",
                user.status === UserStatusEnum.INACTIVE && (React.createElement("span", { style: { color: "#666", fontStyle: "italic" } },
                    " ",
                    intl.formatMessage({
                        id: "ui-czna-users.auditLog.filter.user.archived",
                    }))))); }))))))),
        React.createElement(Accordion, { label: intl.formatMessage({
                id: "ui-czna-users.auditLog.filter.entityType",
            }), separator: false },
            React.createElement(Select, { value: list.filters.entityType, onChange: function (e) {
                    return list.setEntityType(e.target.value);
                } },
                React.createElement("option", { value: "" }, intl.formatMessage({
                    id: "ui-czna-users.auditLog.filter.entityType.placeholder",
                })),
                ENTITY_TYPE_OPTIONS.map(function (opt) { return (React.createElement("option", { key: opt, value: opt }, intl.formatMessage({
                    id: "ui-czna-users.auditLog.entityType.".concat(opt),
                    defaultMessage: opt,
                }))); })))));
    var exportDisabled = list.totalRecords > EXPORT_LIMIT || isExporting;
    var exportButton = (React.createElement(PaneMenu, null, list.totalRecords > EXPORT_LIMIT ? (React.createElement(Tooltip, { text: intl.formatMessage({
            id: "ui-czna-users.auditLog.export.disabled",
        }), id: "export-tooltip" }, function (_a) {
        var ref = _a.ref, ariaIds = _a.ariaIds;
        return (React.createElement(Button, { ref: ref, "aria-describedby": ariaIds.text, buttonStyle: "default", marginBottom0: true, disabled: true },
            React.createElement(FormattedMessage, { id: "ui-czna-users.auditLog.export", values: { count: list.totalRecords } })));
    })) : (React.createElement(Button, { buttonStyle: "default", marginBottom0: true, disabled: exportDisabled, onClick: handleExport }, isExporting ? (React.createElement(Icon, { icon: "spinner-ellipsis" })) : (React.createElement(FormattedMessage, { id: "ui-czna-users.auditLog.export", values: { count: list.totalRecords } }))))));
    var detailPane = selectedId ? (React.createElement(AuditLogDetailPane, { id: selectedId, onClose: goToList })) : undefined;
    return (React.createElement(React.Fragment, null,
        React.createElement(SearchLayout, { list: list, searchPlaceholder: intl.formatMessage({
                id: "ui-czna-users.auditLog.filter.fulltext",
            }), paneTitle: React.createElement(FormattedMessage, { id: "ui-czna-users.auditLog.title" }), filterContent: filterContent, detailPane: detailPane, lastMenu: exportButton }, list.isLoading && list.items.length === 0 ? (React.createElement(Layout, { className: "display-flex flex-direction-column centerContent" },
            React.createElement(Layout, { className: "padding-all-gutter" },
                React.createElement(Loading, { size: "xlarge" })))) : list.items.length === 0 && !list.isLoading ? (list.isDefaultFilters ? (React.createElement(Layout, { className: "display-flex flex-direction-column centerContent" },
            React.createElement(Layout, { className: "padding-all-gutter" },
                React.createElement(Headline, { size: "medium", margin: "none" },
                    React.createElement(FormattedMessage, { id: "ui-czna-users.auditLog.empty.heading" })),
                React.createElement("p", { style: { color: "#666", marginTop: "8px" } },
                    React.createElement(FormattedMessage, { id: "ui-czna-users.auditLog.empty.subtext" }))))) : (React.createElement(Layout, { className: "display-flex flex-direction-column centerContent" },
            React.createElement(Layout, { className: "padding-all-gutter" },
                React.createElement("p", { style: { color: "#666" } },
                    React.createElement(FormattedMessage, { id: "ui-czna-users.auditLog.noResults" })),
                React.createElement(Button, { onClick: list.handleClearFilters, style: { marginTop: "16px" } },
                    React.createElement(FormattedMessage, { id: "ui-czna-users.auditLog.noResults.clearFilters" })))))) : (React.createElement("div", { style: { display: "flex", flexDirection: "column", height: "100%" } },
            React.createElement("div", { style: { flex: 1, minHeight: 0 } },
                React.createElement(MultiColumnList, { autosize: true, virtualize: true, loading: list.isFetching, contentData: list.items, totalCount: list.items.length, columnMapping: {
                        createdAt: (React.createElement(FormattedMessage, { id: "ui-czna-users.auditLog.column.createdAt" })),
                        actionType: (React.createElement(FormattedMessage, { id: "ui-czna-users.auditLog.column.actionType" })),
                        userName: (React.createElement(FormattedMessage, { id: "ui-czna-users.auditLog.column.user" })),
                        entityType: (React.createElement(FormattedMessage, { id: "ui-czna-users.auditLog.column.entity" })),
                        summary: (React.createElement(FormattedMessage, { id: "ui-czna-users.auditLog.column.description" })),
                    }, visibleColumns: [
                        "createdAt",
                        "actionType",
                        "userName",
                        "entityType",
                        "summary",
                    ], formatter: resultsFormatter, selectedRow: selectedId ? { id: selectedId } : undefined, onRowClick: handleRowClick, interactive: true })),
            React.createElement("div", { style: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "0.25rem",
                    padding: "0.5rem 0",
                    borderTop: "1px solid #e8e8e8",
                } },
                React.createElement("div", { style: { display: "flex", alignItems: "center", gap: "1rem" } },
                    React.createElement(Button, { disabled: list.page <= 1, onClick: function () { return list.goToPage(list.page - 1); } },
                        React.createElement(FormattedMessage, { id: "ui-czna-users.auditLog.previousPage" })),
                    React.createElement("span", null,
                        React.createElement(FormattedMessage, { id: "ui-czna-users.auditLog.pagination.info", values: {
                                page: list.page,
                                totalPages: list.totalPages,
                            } })),
                    React.createElement(Button, { disabled: list.page >= list.totalPages, onClick: function () { return list.goToPage(list.page + 1); } },
                        React.createElement(FormattedMessage, { id: "ui-czna-users.auditLog.nextPage" }))),
                React.createElement("span", { style: { color: "#666", fontSize: "0.85em" } },
                    React.createElement(FormattedMessage, { id: "ui-czna-users.auditLog.pagination.showing", values: {
                            from: (list.page - 1) * list.pageSize + 1,
                            to: Math.min(list.page * list.pageSize, list.totalRecords),
                            total: list.totalRecords,
                        } })))))),
        React.createElement(Callout, { ref: calloutRef })));
};
export default AuditLogList;
